// 8am eCheck authorization, copied from
// https://developers.8am.com/collect/payment-page-requirements
// Curly quotes around Submit Payment are required. {firm} is the merchant
// (this firm's name), in both places the page uses <Merchant Name>.

const ECHECK_AUTHORIZATION = 'By clicking \u201cSubmit Payment\u201d, I am authorizing {firm} to initiate a single or recurring ACH/electronic debit in the amount indicated from the bank account I designated above. I understand that this Authorization will remain in full force and effect until the transaction is cancelled by me by contacting {firm}, or the ACH/electronic debit is processed from the designated account. I certify that (1) I am authorized to debit the bank account above and (2) the ACH/electronic payment I am authorizing complies with all applicable laws.';

export function echeckFirmName(cfg, portalName) {
  const fromCfg = cfg && (cfg.firm_name || cfg.merchant_name || (cfg.firm && (cfg.firm.firm_name || cfg.firm.name)));
  if (typeof fromCfg === 'string' && fromCfg.trim()) return fromCfg.trim();
  return String(portalName || '').trim();
}

export function echeckAuthorizationText(firmName, provided) {
  if (typeof provided === 'string' && provided.includes('\u201cSubmit Payment\u201d')) return provided;
  const firm = String(firmName || '').trim();
  return ECHECK_AUTHORIZATION.split('{firm}').join(firm);
}

export function echeckAuthorizationFromConfig(cfg, portalName) {
  const provided = cfg && (
    cfg.authorization_text
    || cfg.echeck_authorization_text
    || (cfg.consent && (cfg.consent.echeck || cfg.consent.authorization_text))
  );
  return echeckAuthorizationText(echeckFirmName(cfg, portalName), provided);
}

// bank === false, or any set bank_unavailable value, means show the notice.
// A missing bank key is not a notice — older configs simply have no bank block.
export function bankUnavailableMessage(cfg) {
  if (!cfg) return '';
  const flag = cfg.bank_unavailable;
  const flagged = flag != null && flag !== false && flag !== '';
  if (cfg.bank !== false && !flagged) return '';
  if (typeof flag === 'string' && flag.trim()) return flag.trim();
  if (flag && typeof flag === 'object') {
    const msg = flag.message || flag.reason || flag.detail || flag.notice;
    if (msg) return String(msg);
  }
  return 'Bank account (eCheck) payments are not available for this firm right now.';
}

export function onlinePayOffered(pay) {
  if (!pay || !pay.enabled) return false;
  if (pay.card || pay.bank || pay.bank_public_key) return true;
  if (pay.bank === false) return true;
  const flag = pay.bank_unavailable;
  return flag != null && flag !== false && flag !== '';
}
